import React from 'react';
import ProductList from './ProductList';
import { AlbumState } from '@/data/models/albumState';
import { useTranslation } from 'react-i18next';
import { loadMerchandiseSubmissionsFilters } from '@/state/actions/productGridActions';
import { FormatType } from '@/data/models/formatType';
import store from '@/state/store';
import { merchandiseProductListColDef } from './MerchandiseProductListColDef';

const defaultMerchandiseStateFilters = [
  AlbumState.Draft,
  AlbumState.UnderReview,
  AlbumState.PendingImport,
  AlbumState.Rejected,
  AlbumState.Error,
];

export default function MerchandiseSubmissionsList() {
  const { t } = useTranslation();

  const storemerchandiseSubmissionsGridParams = (
    searchParams: URLSearchParams | null
  ) => {
    return loadMerchandiseSubmissionsFilters({
      merchandiseSubmissionsGridParams: searchParams,
    });
  };

  const merchandiseSubmissionsGridParams =
    store.getState().productGridState.merchandiseSubmissionsGridParams;

  return (
    <ProductList
      defaultStateFilters={defaultMerchandiseStateFilters}
      productListHeader={t('product.productList.merchandiseSubmissions')}
      storedGridParams={merchandiseSubmissionsGridParams}
      setGridParams={storemerchandiseSubmissionsGridParams}
      formatType={FormatType.Merchandise}
      productListColDef={merchandiseProductListColDef}
      gridName="merchandise-submissions"
    />
  );
}
